import api from '../../api/stoTrade'

export default {
  namespaced: true,
  state: {
    brand: {},
    brands: [],
    brandQuery: '',
    stockType: '2',
    favoriteBrands: [],
    favoriteBrandsMap: {},
    brandsLoading: false,
    lastRemovedBrand: null,
    isLastPage: false,
    addingBrand: false,
    tradeDate: '**:** - **:**',
    exchangeServers: []
  },
  mutations: {
    setBrand(state, brand) {
      if (!brand) return;
      if (Object.keys(brand).length > 0) {
        state.brand = brand;
        if(!brand.exchange_server_code) state.tradeDate ='**:** - **:**';
        else state.tradeDate = brand.trade_start_at + ' - ' + brand.trade_end_at;
      }

    },
    setBrands(state, list) {
      state.brands = list
    },
    clearBrand(state) {
      state.brand = {};
    },
    SET_FAV_BRANDS(state, favoriteBrands) {
      state.favoriteBrandsMap = {}
      favoriteBrands.forEach(brand => {
        state.favoriteBrandsMap[brand.symbol] = brand
      })
      state.favoriteBrands = favoriteBrands;
    },

    SET_EXCHANGE_SERVERS(state, exchangeServers) {
      state.exchangeServers = exchangeServers
    },
    setBrandQuery(state, value) {
      state.brandQuery = value;
    },
    setStockType(state, value) {
      if (!value) {
        state.stockType = '2';
        return;
      }
      state.stockType = value;
    },
    setLoading(state, value) {
      state.brandsLoading = value
    },
    pushBrand(state, value) {
      state.brands.push(...value)
      if (state.brands) {
        state.brands.sort((a, b) => a.symbol - b.symbol);
      }
    },
    setIsLastPage(state, value) {
      state.isLastPage = value
    },
    updateOCHL(state, params) {
      if (!state.brand) return;
      state.brand.opening_price = params.opening_price;
      state.brand.closing_price = params.closing_price;
      state.brand.high_price = params.high_price;
      state.brand.low_price = params.low_price;
    }
  },
  actions: {
    async fetchExchangeServers({commit}) {
      const {
        data: { data },
      } = await api.exchangeServers()

      commit('SET_EXCHANGE_SERVERS', data);
    },
    async fetchFavBrands({ commit }) {
      const {
        data: { data, ...page },
      } = await api.favoriteBrands()

      commit('SET_FAV_BRANDS', data);
    },
    setBrand({ commit }, payload) {
      commit('setBrand', payload);
    },
    setStockType({ commit }, payload) {
      commit('setStockType', payload);
    },
    setFavoriteBrands({ commit }, payload) {
      commit('SET_FAV_BRANDS', payload);
    },
    clearBrand({ commit }) {
      commit('clearBrand');
    },
    removeItemFromFav({ commit }, item) {
      commit('removeFromFav', item);
    },
    async fetchBrands({ commit }, { brandSearchQuery, pageNumber }) {
      try {
        commit('setLoading', true)
        let {
          data: { data, ...page },
        } = await api.brandList({
          word: brandSearchQuery,
          page: pageNumber,
          per_page: 30,
        })

        commit('setIsLastPage', page && page.last_page)
        const isFirstPage = !pageNumber || Number(pageNumber) <= 1
        commit(brandSearchQuery || isFirstPage ? 'setBrands' : 'pushBrand', data)
      } catch (e) {
        console.error(e)
      } finally {
        commit('setLoading', false)
      }
    },
    async updateCurrentSymbol({ commit }, { brand }) {
      console.log('updating: ', brand);
      try {
        commit('setLoading', true)
        const { data } = await api.symbolOCHL(brand.symbol);
        commit('updateOCHL', data)
      } catch (e) {
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getBrand(state) {
      return state.brand;
    },
    tradeDate(state) {
      return state.tradeDate;
    },
  },
};
